import React from "react"
import styled, { css, FlattenInterpolation } from "styled-components"

import { Color, RadiusSize, SpacingSize, TextSize } from "~/consts/style-mixins"

interface Props {
  size: SizeType
  color?: string
  className?: string
}

export const SizeType = {
  Large: "Large",
  Medium: "Medium",
  Small: "Small",
  XS: "XS",
}
export type SizeType = keyof typeof SizeType

const Tag: React.FC<Props> = ({ children, size, className, color }) => {
  return (
    <StyledLabel className={className} styledBySize={StyledBySize[size]} color={color}>
      {children}
    </StyledLabel>
  )
}

export default Tag

const StyledBySize: Record<SizeType, FlattenInterpolation<{}>> = {
  Large: css`
    padding: ${SpacingSize["XS"]}px ${SpacingSize.S}px;
    font-size: ${TextSize.S}px;
  `,
  Medium: css`
    padding: ${SpacingSize["2XS"]}px ${SpacingSize.XS}px;
    font-size: ${TextSize.XS}px;
  `,
  Small: css`
    padding: ${SpacingSize["3XS"]}px ${SpacingSize["2XS"]}px;
    font-size: ${TextSize["2XS"]}px;
  `,
  XS: css`
    padding: ${SpacingSize["3XS"]}px ${SpacingSize["2XS"]}px;
    font-size: ${TextSize["2XS"]}px;
    transform: scale(0.7);
    white-space: nowrap;
  `,
}

type StyledProps = Pick<Props, "color"> & {
  styledBySize: FlattenInterpolation<{}>
}

const StyledLabel = styled.span<StyledProps>`
  display: inline-block;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  text-align: center;
  color: ${Color.White};
  background-color: ${({ color }) => color || Color.Attention};
  border-radius: ${RadiusSize.Medium}px;
  ${({ styledBySize }) => css`
    ${styledBySize}
  `};
`
